<template>

    <LoopItemPanel title="Slide">

        <div class="canvas-blocks-custom-impressionSlider-LoopItemPanel">

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/owlCarousel/LoopItemPanel";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
    },

}
</script>

<style lang="scss" scoped>
